import React from 'react';
import { Database, Cloud, Shield, Users } from 'lucide-react';
import { services } from '../data/mockData';

const iconMap = {
  Database: Database,
  Cloud: Cloud,
  Shield: Shield,
  Users: Users,
};

const ServiceCard = ({ service, index }) => {
  const Icon = iconMap[service.icon];
  const colors = [
    'bg-blue-500/10 border-blue-500/20',
    'bg-teal-500/10 border-teal-500/20',
    'bg-purple-500/10 border-purple-500/20',
    'bg-orange-500/10 border-orange-500/20',
  ];
  const iconColors = ['text-blue-500', 'text-teal-500', 'text-purple-500', 'text-orange-500'];

  return (
    <div
      className={`flex-shrink-0 w-64 p-6 rounded-2xl border backdrop-blur-sm ${colors[index % 4]} transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer`}
    >
      <div className={`w-14 h-14 rounded-xl ${colors[index % 4]} flex items-center justify-center mb-4`}>
        <Icon className={`w-7 h-7 ${iconColors[index % 4]}`} />
      </div>
      <h3 className="text-lg font-semibold text-gray-800">{service.name}</h3>
    </div>
  );
};

const ServicesMarquee = () => {
  // Duplicate services for seamless loop
  const duplicatedServices = [...services, ...services, ...services];

  return (
    <div className="relative bg-gradient-to-b from-blue-200 via-blue-100 to-orange-200 py-16 overflow-hidden">
      {/* First row - left to right */}
      <div className="relative mb-8">
        <div className="flex gap-6 animate-marquee">
          {duplicatedServices.map((service, index) => (
            <ServiceCard key={`row1-${index}`} service={service} index={index % services.length} />
          ))}
        </div>
      </div>

      {/* Gradient overlays */}
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-blue-200 to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-orange-200 to-transparent z-10" />
    </div>
  );
};

export default ServicesMarquee;
